import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { canonicalFor, usePageMeta } from '../hooks/usePageMeta';
import { CONTACT } from '../data/navigation';
import type { ComingSoonPage as ComingSoonPageData } from '../data/comingSoon';
interface ComingSoonProps {
  page: ComingSoonPageData;
}
export function ComingSoon({
  page
}: ComingSoonProps) {
  usePageMeta({
    title: page.title,
    description: page.description,
    canonical: canonicalFor(page.path),
    robots: 'noindex,follow'
  });
  return <section aria-labelledby="cs-heading" className="w-full bg-warm" data-id="element-376" data-mp="97u665h2ibff">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-377" data-mp="n0js69wljgcj">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:gap-20" data-id="element-378" data-mp="i305cllu1v8z">
          <div data-id="element-379" data-mp="x0arqq00kljh">
            <p className="flex items-center gap-3 font-mono text-[10px] tracking-label text-copper" data-id="element-380" data-mp="wzr7v3qszn2t">
              <span aria-hidden="true" className="h-px w-8 bg-copper" data-id="element-381" data-mp="s1pp6jxahprv" />
              {page.eyebrow.toUpperCase()}
            </p>
            <p className="mt-5 inline-flex border border-navy/20 bg-white px-2.5 py-1 font-mono text-[10px] tracking-label text-navy" data-id="element-382" data-mp="x8csprq69yi5">
              COMING SOON
            </p>
            <h1 id="cs-heading" className="mt-5 max-w-[20ch] font-display text-[clamp(2rem,4vw,3.4rem)] font-medium leading-[1.05] tracking-[-0.02em] text-navy" data-id="element-383" data-mp="165da3eetqwc3">
              {page.h1}
            </h1>
            <p className="rp-measure mt-7 text-[16px] leading-[1.7] text-graphite/85" data-id="element-384" data-mp="1l3p93rpo6h6f">
              {page.paragraph}
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-385" data-mp="1pvytytbxgr1u">
              <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="coming-soon" className="inline-flex min-h-[52px] items-center justify-center gap-2 bg-cta px-7 text-[14.5px] font-semibold text-navy transition-colors duration-150 ease-precise hover:bg-navy hover:text-white" data-id="element-386" data-mp="1twit22g2a4qm">
                Request Product Guidance
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-387" data-mp="3v0bgki69bs1q" />
              </Link>
              <Link to="/" className="inline-flex min-h-[52px] items-center justify-center gap-2 border border-rule px-7 text-[14.5px] font-medium text-navy transition-colors duration-150 ease-precise hover:border-copper hover:text-copper" data-id="element-388" data-mp="djbh7nlt0to9">
                <ArrowLeftIcon aria-hidden="true" className="h-4 w-4" data-id="element-389" data-mp="igk1btqij7s5" />
                Return Home
              </Link>
            </div>
          </div>

          <aside className="rp-grid-lines self-start border border-rule bg-white p-6 lg:p-8" data-id="element-390" data-mp="ri1f35gg6xdo">
            <h2 className="font-mono text-[10px] tracking-label text-copper" data-id="element-391" data-mp="2y7zj1qlxliwl">
              DIRECT CONTACT
            </h2>
            <dl className="mt-5 divide-y divide-rule border-y border-rule" data-id="element-392" data-mp="2t9y2pdfw3xot">
              <div className="py-3.5" data-id="element-393" data-mp="18rdrzstpbsfb">
                <dt className="font-mono text-[9.5px] tracking-label text-graphite/60" data-id="element-394" data-mp="18sf0bpjc20tc">
                  PHONE
                </dt>
                <dd className="mt-1" data-id="element-395" data-mp="1ds9vw6e1zekq">
                  <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-location="coming-soon" className="font-mono text-[15px] text-navy underline decoration-copper underline-offset-4" data-id="element-396" data-mp="z1u428r4t8dl">
                    {CONTACT.phoneLabel}
                  </a>
                </dd>
              </div>
              <div className="py-3.5" data-id="element-397" data-mp="g387962ne3fh">
                <dt className="font-mono text-[9.5px] tracking-label text-graphite/60" data-id="element-398" data-mp="g49fl2sa4bti">
                  EMAIL
                </dt>
                <dd className="mt-1" data-id="element-399" data-mp="2agpj3vtoxbuo">
                  <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="coming-soon" className="break-all text-[15px] text-navy underline decoration-copper underline-offset-4" data-id="element-400" data-mp="2ahr7f1zpvuuc">
                    {CONTACT.email}
                  </a>
                </dd>
              </div>
              <div className="py-3.5" data-id="element-401" data-mp="6bbj353v303z">
                <dt className="font-mono text-[9.5px] tracking-label text-graphite/60" data-id="element-402" data-mp="6efx0u74pa7u">
                  MAILING ADDRESS
                </dt>
                <dd className="mt-1 text-[14.5px] leading-relaxed text-graphite/85" data-id="element-403" data-mp="3sk33xvsm5e0q">
                  {CONTACT.mailingAddress}
                </dd>
              </div>
            </dl>
          </aside>
        </div>
      </div>
    </section>;
}